import script from "./SideFloatingBanner.vue?vue&type=script&setup=true&lang=js"
export * from "./SideFloatingBanner.vue?vue&type=script&setup=true&lang=js"

import "./SideFloatingBanner.vue?vue&type=style&index=0&id=2b53d0ab&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2b53d0ab"]])

export default __exports__